<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="section">
          <div class="section-content padding-top-20">
            <PlaybookSectionVideos :videos = videoData videoGroup = "TROUBLESHOOTING" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PlaybookSectionVideos from "@/components/playbook/PlaybookSectionVideos";

export default {
  name: "Troubleshooting",
  components : { PlaybookSectionVideos},
  data () {
    return {
      videoData : [
        {
          id: 0,
          title: this.$t('PLAYBOOK.troubleshooting.changeBattery'),
          src: 'https://www.youtube-nocookie.com/embed/4ZIZbKgT-HQ'
        },
        {
          id: 1,
          title: this.$t('PLAYBOOK.troubleshooting.resetBelt'),
          src: 'https://www.youtube-nocookie.com/embed/E2bDVNEzFrE?rel=0'
        }
      ]
    }
  }
}
</script>

<style>
.container-fluid .img-fluid{
   height: 500px;
 }

 .carousel.slide{
   padding: 0 10%;
 }

 .video-wrapper{
position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;
 }
 .video-wrapper iframe{
position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
 }
</style>